import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AppContext from "../AppContext";
import CompanyDashboard from "./dashboard/CompanyDashboard";
import { RoleEnum } from "../Constants";
import SuperAdminDashboard from "./dashboard/SuperAdminDashboard";

function DashboardRouter() {
  const authCtx = useContext(AppContext);

  if (authCtx.profile.role === RoleEnum.SUPER_ADMIN) {
    return <SuperAdminDashboard />;
  }

  // Individual Event/Wedding accounts are virtual companies — there is no generic
  // company dashboard for them, so send them to the Events surface instead. Before event
  // access is granted (payment still pending), /events would bounce back here, so send them
  // to My Packages to complete payment.
  if (authCtx.isVirtual) {
    return <Navigate to={authCtx.hasEventAccess ? "/events" : "/my-packages"} replace />;
  }

  return <CompanyDashboard />;
}

export default DashboardRouter;
